import React, { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import { beginStaffGoogle, staffGoogleEnabled, staffGoogleMessage } from '../../../services/staffGoogle'

export function GoogleContinueButton({ purpose }) {
  const { formatMessage: trans } = useIntl()
  const [enabled, setEnabled] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const lock = useRef(false)

  useEffect(() => {
    let cancel = false
    staffGoogleEnabled().then((on) => {
      if (!cancel) setEnabled(on)
    })
    return () => {
      cancel = true
    }
  }, [])

  if (!enabled) return null

  const start = () => {
    if (lock.current) return
    lock.current = true
    setBusy(true)
    setError('')
    beginStaffGoogle(purpose).catch((err) => {
      lock.current = false
      setBusy(false)
      setError(staffGoogleMessage(trans, { code: err.code, message: err.message }))
    })
  }

  return (
    <>
      <button type="button" className="google-button" onClick={start} disabled={busy} aria-busy={busy}>
        {busy
          ? trans({ id: 'staff_google_return_working', defaultMessage: 'Contacting Google…' })
          : trans({ id: 'staff_google_continue', defaultMessage: 'Continue with Google' })}
      </button>
      {error ? (
        <p className="message_error" role="alert">
          {error}
        </p>
      ) : null}
    </>
  )
}
